import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const timeslotCollectorService = {};

timeslotCollectorService.getTimeslotCollectorList = params => {
  const columnFilter = params.columnFilter || {};
  return fetchV2({
    url: `${env.API_MSP}/collector/time-slots`,
    method: "GET",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort,
      keywords: params.keywords,
      expand: params.expand,
    },
  });
};

timeslotCollectorService.createTimeslotCollector = data => {
  return fetchV2({
    url: `${env.API_MSP}/collector/time-slots`,
    method: "POST",
    data,
  });
};

timeslotCollectorService.updateTimeslotCollector = ({ id, data }) => {
  return fetchV2({
    url: `${env.API_MSP}/collector/time-slots/${id}`,
    method: "PUT",
    data,
  });
};

timeslotCollectorService.updateStatusTimeslotCollector = ({
  id,
  record_status,
}) => {
  return fetchV2({
    url: `${env.API_MSP}/collector/time-slots/${id}`,
    method: "PUT",
    data: {
      record_status,
    },
  });
};

timeslotCollectorService.getTimeSlotsSchedule = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/collector/collector-schedule-changes/get-time-slot`,
    method: "get",
    params: {
      date: params.date || undefined,
      hub_id: params.hub_id || undefined,
    },
  });
};

export default timeslotCollectorService;
